import { useEffect, useRef, useState } from "react";
import maplibregl from "maplibre-gl";
import { bbox } from "@turf/turf";

export default function Map({ routes }) {
    const mapRef = useRef(null);
    const mapInstance = useRef(null);
    const [hovered, setHovered] = useState(null);

    const formatDate = (dateStr) => {
        const d = new Date(dateStr);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${day}-${month}-${year}`;
    };

    const formatTime = (seconds) => {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);

        return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    };

    const getSpeed = (distanceMeters, movingTimeSeconds) => {
        const km = distanceMeters / 1000;
        const hours = movingTimeSeconds / 3600;

        if (hours === 0) return 0;

        return (km / hours).toFixed(1); // bijv. 27.3 km/h
    };

    useEffect(() => {
        if (!routes) return;

        // init map (1x)
        if (!mapInstance.current) {
            mapInstance.current = new maplibregl.Map({
                container: mapRef.current,
                // style: "https://demotiles.maplibre.org/style.json",
                style: "https://tiles.openfreemap.org/styles/liberty"
                // center: [points[0][1], points[0][0]],
                // zoom: 0.1,
            });

            // const bbx = bbox(routes);

            // // Fit the map to the bounding box
            // mapInstance.current.fitBounds(bbx, {
            //     padding: 20 // Optional padding
            // });

            mapInstance.current.on("load", () => {
                addRoutes(mapInstance.current, routes);

                let hoveredId = null;

                mapInstance.current.on("mouseenter", "routes", () => {
                    mapInstance.current.getCanvas().style.cursor = "pointer";
                });

                mapInstance.current.on("mousemove", "routes", (e) => {
                    if (e.features.length === 0) {
                        if (hoveredId !== null) {
                            mapInstance.current.setFeatureState(
                                { source: "routes", id: hoveredId },
                                { hover: false }
                            );
                        }
                        hoveredId = null;
                        setHovered(null);
                        return;
                    }

                    const newId = e.features[0].id;

                    if (hoveredId !== null && hoveredId !== newId) {
                        mapInstance.current.setFeatureState(
                            { source: "routes", id: hoveredId },
                            { hover: false }
                        );
                    }

                    hoveredId = newId;

                    mapInstance.current.setFeatureState(
                        { source: "routes", id: hoveredId },
                        { hover: true }
                    );

                    setHovered(e.features[0].properties);
                });

                mapInstance.current.on("mouseleave", "routes", () => {
                    setHovered(null);
                    mapInstance.current.getCanvas().style.cursor = "";
                    if (hoveredId !== null) {
                        mapInstance.current.setFeatureState(
                            { source: "routes", id: hoveredId },
                            { hover: false }
                        );
                    }
                    hoveredId = null;
                });

            });
        } else {

            addRoutes(mapInstance.current, routes);
        }
    }, [routes]);

    function addRoutes(map, routes) {
        const features = routes.map(r => ({
            type: "Feature",
            id: r.id,
            properties: {
                name: r.name,
                date: r.date,
                description: r.description,
                duration: r.duration,
                athlete: r.athlete,
                distance: (Number(r.distance) / 1000).toFixed(2), // convert to km,
            },
            geometry: {
                type: "LineString",
                coordinates: r.points.map(p => {
                    let lon = p[1];
                    if (lon > 180) lon -= 360;
                    if (lon < -180) lon += 360;
                    return [lon, p[0]]; // lon, lat
                })
            }
        }));

        const geojson = {
            type: "FeatureCollection",
            features
        };

        if (map.getSource("routes")) {
            map.getSource("routes").setData(geojson);
        } else {
            map.addSource("routes", {
                type: "geojson",
                data: geojson
            });

            map.addLayer({
                id: "routes",
                type: "line",
                source: "routes",
                paint: {
                    "line-color": "#ff0000",
                    "line-width": [
                        "case",
                        ["boolean", ["feature-state", "hover"], false],
                        6,
                        3
                    ],
                    "line-opacity": [
                        "case",
                        ["boolean", ["feature-state", "hover"], false],
                        1.0,
                        0.3
                    ]
                }
            });
        }

        // zoom op ALLE routes
        // const allCoords = features.flatMap(f => f.geometry.coordinates);

        // // map.fitBounds(allCoords, {
        // //     padding: 50,
        // //     maxZoom: 9
        // // });
        // map.fitBounds(allCoords);

        const bounds = bbox(geojson); // geojson = FeatureCollection
        map.fitBounds([
            [bounds[0], bounds[1]],
            [bounds[2], bounds[3]]
        ], {
            padding: 50,
            maxZoom: 9
        });
    }
    // className="map-container" 
    return <div style={{ position: "absolute", top: 0, height: "100vh", width: "100%", zIndex: 0 }}>
        <div ref={mapRef} style={{ height: "100%", width: "100%" }}  />
        {hovered && (
            <div className="map-info">
                <strong>{hovered.name}</strong><br />
                <em>{hovered.description}</em><br />
                <small>{hovered.athlete}</small><br />
                <label>Datum:</label>{formatDate(hovered.date)}<br />
                <label>Afstand:</label>{hovered.distance} km<br />
                <label>Duur:</label>{formatTime(hovered.duration)}<br />
                <label>Gem. snelheid:</label>{getSpeed(hovered.distance * 1000, hovered.duration)} km/h
            </div>
        )}
    </div>; ////<div ref={mapRef} style={{ height: "500px", width: "100%" }} />;
}